<script setup lang="ts">
/**
 * The template's dark marquee band: big white headings separated by a white
 * star, scrolling continuously. The list is rendered twice so the loop has no
 * visible seam; the CSS animation moves the strip by exactly half its width.
 */
const props = defineProps<{
  items: string[]
}>()

const strip = computed(() => [...props.items, ...props.items])
</script>

<template>
  <div class="sofax overflow-hidden bg-ink py-8 dark:bg-gray-900 lg:py-10 xl:py-[3.125rem]" aria-hidden="true">
    <div class="infinite-text-slider gap-6 whitespace-nowrap">
      <div v-for="(item, index) in strip" :key="`${item}-${index}`" class="mx-6 flex items-center">
        <div class="display-heading display-heading-2 !text-white">{{ item }}</div>
        <img
          src="/sofax/text-star-white.svg"
          alt=""
          width="57"
          height="55"
          class="mx-6 inline-block size-10 md:size-14"
        >
      </div>
    </div>
  </div>
</template>
